export default __webpack_public_path__ + "static/media/colecao.fa2f09f1.webp";